import { Link } from 'react-router-dom';

/**
 * The one page that is not a screen.
 *
 * It names what happened and offers the next action, like every other error
 * surface in the product. It is deliberately not a "coming soon" page: a route
 * that exists but does nothing is worse than one that says it does not exist.
 */
export function NotFound(): JSX.Element {
  return (
    <main className="mx-auto flex max-w-reading flex-col gap-4 p-6" data-component="NotFound">
      <h1 className="text-h2 font-medium text-ink">That page does not exist</h1>
      <p className="text-body text-ink-meta">
        The link may be out of date, or the area it belongs to may be switched off for this workspace.
      </p>
      <p>
        <Link className="text-bronze-text underline" to="/">
          Go to Home
        </Link>
      </p>
    </main>
  );
}
